import API from '@/api';
import moment from 'moment';
import * as types from '@/store/mutationTypes';
import _ from 'lodash';
import Vue from 'vue';

const state = {
  companyId: null,
  bills: [],
  invoices: [],
  loadingTransactions: false,
  timestamp: null,
};

const getters = {
  billTransactions: qbState => qbState.bills,
  invoiceTransactions: qbState => qbState.invoices,
  companyId: qbState => qbState.companyId,
  timestamp: qbState => qbState.timestamp,
  loadingTransactions: qbState => qbState.loadingTransactions,
};

const mutations = {
  [types.START_LOADING](loadState) {
    loadState.loadingTransactions = true; // eslint-disable-line no-param-reassign
  },
  [types.SET_LOAD_TRANSACTIONS](loadState, { txns, companyId, loading }) {
    loadState.bills = txns.bills || []; // eslint-disable-line no-param-reassign
    loadState.invoices = txns.invoices || []; // eslint-disable-line no-param-reassign

    loadState.companyId = companyId;// eslint-disable-line no-param-reassign
    loadState.loadingTransactions = loading; // eslint-disable-line no-param-reassign
    loadState.timestamp = moment(); // eslint-disable-line no-param-reassign
  },
  [types.UPDATE_LOAD_TRANSACTION](loadState, txData) {
    let txIndex = _.findIndex(loadState.bills, tx => tx.id === txData.id);
    if (txIndex > -1) {
      Vue.set(loadState.bills, txIndex, txData);
    } else {
      txIndex = _.findIndex(loadState.invoices, tx => tx.id === txData.id);
      Vue.set(loadState.invoices, txIndex, txData);
    }
  },
  [types.REMOVE_LOAD_TRANSACTION](loadState, txId) {
    loadState.bills = _.reject(loadState.bills, { id: txId }); // eslint-disable-line no-param-reassign
    loadState.invoices = _.reject(loadState.invoices, { id: txId }); // eslint-disable-line no-param-reassign
  },
};

const actions = {
  async getLoadTransactions({ commit, dispatch }, companyId) {
    try {
      commit(types.START_LOADING);
      const response = await API.settlements.getDashboardV2({ companyId });

      commit(types.SET_LOAD_TRANSACTIONS, { txns: response.data, companyId, loading: false });
    } catch (error) {
      dispatch('applications/setErrorNotification', {
        message: error.message,
      }, { root: true });
    }
  },
  updateLoadTransaction({ commit }, txData) {
    commit(types.UPDATE_DISPATCH_REQUEST, txData);
  },
  removeTransaction({ commit }, txId) {
    commit(types.REMOVE_LOAD_TRANSACTION, txId);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/loadTransactions.js